import { Component, getAttributeParser } from '@mycolorway/tao';
import $ from 'jquery';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-datatable', {
  mixins: [eventListenerMixin],

  properties: {
    currentPage: {
      type: Number,
      default: 1,
    },
    url: {
      type: String,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
  },

  init() {
    this.selectedRows = [];
  },

  connected() {
    this.tableWrapper = this.querySelector('.table-wrapper');

    this.listenTo(this.tableWrapper, {
      'tr-table:rowSelected': this.handleTableRowSelected.bind(this),
      'tr-table:selectedChange': this.handleTableSelectedChange.bind(this),
    });

    this.listenTo(this, 'input', this.handleSearchInputChange.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  replaceWith(datatable, { keepSelected = true } = {}) {
    const doc = new DOMParser().parseFromString(datatable, 'text/html');

    if (!keepSelected) {
      const oldToolbar = this.querySelector('.toolbar');
      const toolbar = doc.body.querySelector('.toolbar');

      if (oldToolbar) this.removeChild(oldToolbar);
      if (toolbar) this.insertAdjacentElement('afterbegin', toolbar);

      this.selectedRows = [];
    }

    this.tableWrapper.replaceChild(
      doc.body.querySelector('tr-table'),
      this.tableWrapper.querySelector('tr-table'),
    );

    const oldPagination = this.querySelector('tr-pagination');
    const pagination = doc.body.querySelector('tr-pagination');

    if (oldPagination) this.removeChild(oldPagination);
    if (pagination) this.insertAdjacentElement('beforeend', pagination);

    if (keepSelected) this.updateTableRowSelected();

    this.updateProperties(doc.body.querySelector('tr-datatable'));
  },

  clearSelected() {
    this.selectedRows = [];
    this.updateControlButtonsParams();
  },

  removeRow(rowId) {
    this.removeRows([rowId]);
  },

  removeRows(rowIds) {
    if (!rowIds || rowIds.length === 0) return;

    const selectors = rowIds.map(id => `tr[data-id="${id}"]`);
    [...this.querySelectorAll(selectors.join(','))].forEach(row => row.remove());
  },

  fetch(params = {}) {
    $.ajax({
      url: this.url,
      method: 'get',
      data: params,
      dataType: 'script',
    });
  },

  updateProperties(datatable) {
    this.searchable = getAttributeParser(Boolean).parse(datatable.getAttribute('searchable'));
    this.currentPage = getAttributeParser(Number).parse(datatable.getAttribute('current-page'));
    this.url = getAttributeParser(String).parse(datatable.getAttribute('url'));
  },

  handleTableRowSelected(event) {
    event.stopPropagation();

    const { row, selected } = event.detail;
    const selectedIndex = this.selectedRows.findIndex(r => r.dataset.id === row.dataset.id);

    if (selected && selectedIndex === -1) {
      this.selectedRows.push(row);
    } else if (selectedIndex !== -1) {
      this.selectedRows.splice(selectedIndex, 1);
    }
  },

  handleTableSelectedChange() {
    this.updateControlButtonsParams();
  },

  updateControlButtonsParams() {
    const selectedIds = this.selectedRows.map(row => row.dataset.id);

    [...this.querySelectorAll('.toolbar [data-selected-param-key]')].forEach((button) => {
      // eslint-disable-next-line no-param-reassign
      button.disabled = this.selectedRows.length === 0;

      const params = JSON.parse(button.dataset.extraParams || '{}');

      $(button).removeData('params'); // wtf: jquery save the data even the data attribute changed
      button.setAttribute('data-params', $.param(Object.assign({
        [button.dataset.selectedParamKey]: selectedIds,
      }, params)));
    });
  },

  updateTableRowSelected() {
    const table = this.querySelector('tr-table');
    table.getRows().forEach((row) => {
      const selected = this.selectedRows.find(r => r.dataset.id === row.dataset.id);
      if (selected) {
        table.selectRow(row);
        table.refreshAllCheckbox();
      }
    });
  },

  handleSearchInputChange(event) {
    const input = closest(event.target, '.search-input');
    if (this.searchable && this.url && input) {
      this.fetch({ search: event.target.value });
    }
  },
});
